// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-nav-item{display:block;height:100%;position:relative;text-wrap:nowrap}.base-nav-item:after{background:currentColor;border-radius:2px;bottom:-5px;content:\"\";height:1.5px;left:50%;position:absolute;transform:translateX(-50%);transition:width .1s ease-in-out;width:0}.base-nav-item.nuxt-link-active:after,.base-nav-item.nuxt-link-exact-active:after,.base-nav-item:hover:after{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
